module.exports = __webpack_public_path__ + "static/img/4986_phase_function_Paper_Points.d4264cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4986_phase_function_Paper_Points.png
// module id = o9dC
// module chunks = 0